import React from "react";

import StatusColumn from "../cells/StatusColumn";
import DateCell from "../cells/DateColumn";

export const APPROVAL_COLUMNS = [
	{
		key: "creativeName",
		name: "Creative",
		className:"name-cell",
		cellClass:"cypress-qa-submission-creative-name",
		resizable:true,
		sortable:true,
		formatter({ dependentValues }){
			return dependentValues?.name;
		},
		getRowMetaData(data){
			return data?.creative || { name:"" };
		},
	}, {
		key: "creativeId",
		name: "ID",
		className:"id-cell",
		cellClass:"cypress-qa-submission-creative-id",
		width:80,
		resizable:false,
		sortable:true,
		formatter({ dependentValues }){
			return dependentValues?.id;
		},
		getRowMetaData(data){
			return data?.creative || { id:"" };
		},
	}, {
		key: "name",
		name: "Status",
		cellClass:"cypress-qa-submitted-status",
		width: 130,
		sortable: true,
		formatter({ dependentValues }){
			// We need to format this because `<StatusColumn />` expects the `value` to be the property
			// However, sorting this column happens on the `name` property, which means the `value` from the grid is wrong
			return <StatusColumn value={dependentValues.approval} dependentValues={dependentValues} />;
		},
		getRowMetaData(data){
			return data;
		},
	}, {
		...DateCell,
		key:"dateCreated",
		cellClass:"cypress-qa-submitted-date",
	}, {
		key:"notes",
		name:"Submission Notes",
		sortable:false,
		cellClass:"cypress-qa-submitted-notes",
	}, {
		key:"username",
		name:"User",
		sortable:true,
		cellClass:"cypress-qa-submitted-user",
		formatter({ dependentValues }){
			return dependentValues.name;
		},
		getRowMetaData(data){
			return data?.user || { name:"" };
		},
	}
];
